// 9fbef606107a605d69c0edbcd8029e5d
export const ARROW_VISIBLE_SIMILAR_PRODUCTS = {
  1200: 3,
  1440: 3,
  1920: 3,
  default: 2,
};

export const SLIDES_TO_SCROLL_SIMILAR_PRODUCTS = {
  1200: 1,
  1440: 1,
  1920: 1,
  default: 1,
};

export const calculateBreakPointByWidth = ([innerWidth]) => {
  if (innerWidth < 1440) return 1200;
  if (innerWidth < 1920) return 1440;
  if (innerWidth >= 1920) return 1920;
  return 'default';
};
